// extracted by mini-css-extract-plugin
module.exports = {"icon":"e_Jz"};